export enum PaymentType {
  CARD = 'Tarjeta Débito/Crédito',
  CASH = 'Efectivo',
  ONLINE = 'En línea',
}
